import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from 'vue';
import {useFormNavigation} from '@/components/calculator/form/useSimulationForm';
import MultiformDictionaries from '@/modules/multiForm/shared/MultiformDictionaries';
import {FFIncome} from '@/models/ExpertState';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {FFIncomeType, IncomeFormType} from '@/modules/multiForm/shared/Types';
import EnvironmentService from '@/env/EnvironmentService';
interface FpInput {
  value: number;
  inputCallback: (value: number) => void,
}
interface ComponentRef<T> {
  value?: T,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormStep3',
  props: {
    income: { default: null },
    incomeNumber: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { income: FFIncome, incomeNumber: number }


const formNavigation = useFormNavigation();
const twelveMonthsAverageInput = ref<Nullable<ComponentRef<FpInput>>>(null);
const sixMonthsAverageInput = ref<Nullable<ComponentRef<FpInput>>>(null);
const incomeDeliveredOnOptions = [{type: 'bankAccount', name_pl: I18NGetter().useSimulationFormStep3.ACCOUNT,}, {type: 'cash', name_pl: I18NGetter().useSimulationFormStep3.CASH,},] as const;
const shouldDisplayFormTypeOf = (formType: IncomeFormType) => {
  return props.income && MultiformDictionaries.incomeTypesByFormType[formType].includes(props.income.incomeTypeId);
}
const getIncomeNameByType = (incomeTypeId: FFIncomeType): string =>
  MultiformDictionaries.allIncomeTypesDictionary.find(({type,}) => type === incomeTypeId)?.name_pl ?? '';
const CURRENT_YEAR: number = new Date().getFullYear();

const shouldDisplayRentIncome =
  computed<boolean>(() => EnvironmentService.Environment.isAppDomain().NESTO_RO && shouldDisplayFormTypeOf(IncomeFormType.RENT_INCOME_TYPE_FORM))
const shouldDisplayGeneralActivitiesIncome =
  computed<boolean>(() => EnvironmentService.Environment.isAppDomain().NESTO_RO && shouldDisplayFormTypeOf(IncomeFormType.GENERAL_ACTIVITIES_INCOME_TYPE_FORM))
const onThreeMonthsAverageInput = (value: number) => {
  if (!sixMonthsAverageInput.value?.value) {
    (sixMonthsAverageInput.value as unknown as FpInput).inputCallback(value);
  }
  if (!twelveMonthsAverageInput.value?.value) {
    (twelveMonthsAverageInput.value as unknown as FpInput).inputCallback(value);
  }
}


return { __sfc: true,props, formNavigation, twelveMonthsAverageInput, sixMonthsAverageInput, incomeDeliveredOnOptions, shouldDisplayFormTypeOf, getIncomeNameByType, CURRENT_YEAR, shouldDisplayRentIncome, shouldDisplayGeneralActivitiesIncome, onThreeMonthsAverageInput, MultiformDictionaries, I18NGetter, IncomeFormType }
}

})